import { render, staticRenderFns } from "./dynamic-atList.vue?vue&type=template&id=050b5514&scoped=true&"
import script from "./dynamic-atList.vue?vue&type=script&lang=js&"
export * from "./dynamic-atList.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-atList.vue?vue&type=style&index=0&id=050b5514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b5514",
  null
  
)

export default component.exports